/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import classNames from 'classnames';
import React, { AnchorHTMLAttributes, FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './DropdownItem.module.scss';

interface IDropdownItemProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href?: string
  active?: boolean
  to?: string
  disabled?: boolean
}

const DropdownItem: FC<IDropdownItemProps> = ({
  className, children, active, disabled, to, href, ...props
}) => (to
  ? (
    <Link
      className={classNames(styles.dropdownItem, className, {
        [styles.active]: active,
        [styles.disabled]: disabled,
      })}
      to={to}
      {...props}
    >
      {children}

    </Link>
  ) : (
    <a
      className={classNames(styles.dropdownItem, className, {
        [styles.disabled]: disabled,
      })}
      href={href}
      {...props}
    >
      {children}
    </a>
  )
);

export default DropdownItem;
